import React, { FC } from 'react'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import { paymentDays, paymentDayShortLabels } from 'constants/paymentDay'
import { IPaymentDay, PaymentDayEnum } from 'typescript/interfaces/paymentDay'

interface IPaymentDaySelectorProps {
  value?: IPaymentDay | '' | null
  disabled?: boolean
  onChange: (value: IPaymentDay) => void
}

const usePaymentDaySelectorStyles = makeStyles(theme => ({
  hint: {
    color: theme.palette.secondary.dark,
    fontSize: '1rem',
    marginBottom: '0.75rem',
  },
  group: {
    width: '100%',
  },
  button: {
    width: 'auto',
    flex: 1,
    minWidth: '3.25rem',
    padding: '0 0.5rem',
    fontSize: '1rem',
    textTransform: 'none',
    color: theme.palette.text.secondary,
    '&$selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  selected: {},
}))

const PaymentDaySelector: FC<IPaymentDaySelectorProps> = ({ value, disabled, onChange }) => {
  const classes = usePaymentDaySelectorStyles()

  return (
    <>
      <Typography className={classes.hint}>The day of the week every payment is collected on</Typography>
      <ToggleButtonGroup
        exclusive
        className={classes.group}
        value={value || null}
        onChange={(_, newValue: PaymentDayEnum | null) => {
          if (newValue) onChange(newValue)
        }}
      >
        {paymentDays.map(day => (
          <ToggleButton key={day} value={day} disabled={disabled} classes={{ root: classes.button, selected: classes.selected }}>
            {paymentDayShortLabels[day as PaymentDayEnum]}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  )
}

export default PaymentDaySelector
